import React from "react";
import { useField } from "react-final-form";
import { CheckCircle, Error as ErrorIcon } from "@mui/icons-material";
import { Alert, Box, Chip } from "@mui/material";

export const FileList: React.FC = () => {
  const { input, meta } = useField<File[]>("Files");
  const files = input.value || [];
  const hasError = meta.error && meta.touched;

  if (files.length === 0) return null;

  const handleDelete = (fileName: string) => {
    const newFiles = files.filter((f) => f.name !== fileName);
    input.onChange(newFiles);
    input.onBlur();
  };

  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
        {files.map((file) => (
          <Chip
            key={file.name}
            label={file.name}
            size="small"
            icon={hasError ? <ErrorIcon /> : <CheckCircle />}
            color={hasError ? "error" : "success"}
            variant="outlined"
            onDelete={() => handleDelete(file.name)}
          />
        ))}
      </Box>
      {hasError && (
        <Alert severity="error" variant="outlined" sx={{ mt: 2 }}>
          {meta.error}
        </Alert>
      )}
    </>
  );
};
